import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule, NgClass, NgIf, ViewportScroller } from '@angular/common';
import { RouterOutlet, Router, Event, NavigationEnd } from '@angular/router';
import { SidebarComponent } from './common/sidebar/sidebar.component';
import { HeaderComponent } from './common/header/header.component';
import { FooterComponent } from './common/footer/footer.component';
import { CustomizerSettingsService } from './customizer-settings/customizer-settings.service';
import { ToggleService } from './common/sidebar/toggle.service';
import { AuthService } from './authentication/service/auth.service';
import { LoadingService } from './authentication/service/loading.service';
import { WelcomeLoaderComponent } from './common/welcome-loader/welcome-loader.component';

@Component({
    selector: 'app-root',
    imports: [
        RouterOutlet,
        CommonModule,
        SidebarComponent,
        HeaderComponent,
        FooterComponent,
        NgClass,
        NgIf,
        WelcomeLoaderComponent
    ],
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
    isLoading: boolean = true;
    // Title
    title = 'Daxa - Angular 18 Material Design Admin Dashboard Template';

    // isSidebarToggled
    isSidebarToggled = false;

    // isToggled
    isToggled = false;

    constructor(
        public router: Router,
        private toggleService: ToggleService,
        private viewportScroller: ViewportScroller,
        public themeService: CustomizerSettingsService,
        private authService: AuthService,
        private loadingService: LoadingService
    ) {
        this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                // Scroll to the top after each navigation end
                this.viewportScroller.scrollToPosition([0, 0]);
            }
        });
        this.toggleService.isSidebarToggled$.subscribe(isSidebarToggled => {
            this.isSidebarToggled = isSidebarToggled;
        });
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }

    ngOnInit() {
        this.loadingService.loading$.subscribe(isLoading => {
            this.isLoading = isLoading;
        });

        this.checkAuthentication();
    }

    checkAuthentication() {
        if (!this.authService.hasTokenExpired()) {
            this.authService.getCurrentUserInfo();
        }
    }
}
